// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"452cc2c3","131":"973e2e72","145":"5b61ce50","302":"8e4b964a","388":"68045a3b","409":"0c23bd32","418":"e67223e5","693":"d374ccf6","694":"f523441d","695":"0c305da0","773":"362b32e9","813":"f1d76207","901":"1942eea1","987":"d9fbc39a"}[chunkId] + ".chunk.js";
};